import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InquiryRoutingModule } from './inquiry-routing.module';
import { ListComponent } from './components/list/list.component';
import { ViewInquiryComponent } from './components/modals/view-inquiry/view-inquiry.component';


@NgModule({
  declarations: [ListComponent, ViewInquiryComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    SharedModule,
    InquiryRoutingModule,
    NgbModalModule
  ],

})
export class InquiryModule { }
